import { useEffect } from "react";

import { useAuth } from "~/contexts/AuthProvider";
import { useTeam } from "~/contexts/TeamProvider";
import {
  REDITUS_CONVERSION_STORAGE_KEY,
  handleReditusPendingConversion,
} from "~/tracking/reditus";

export function ReditusConversionFlusher() {
  const { user } = useAuth();
  const { team } = useTeam();

  const email = user?.email ?? null;
  const teamId = team?.id ?? null;
  const uid = team?.stripe_id ?? null;

  const shouldFlush =
    Boolean(localStorage.getItem(REDITUS_CONVERSION_STORAGE_KEY)) &&
    Boolean(teamId && email && uid);

  useEffect(() => {
    if (!shouldFlush) return;

    handleReditusPendingConversion({
      teamId: teamId as number,
      email: email as string,
      uid: uid as string,
    });
  }, [shouldFlush, teamId, uid]);

  return null;
}
